import { Loader } from "../Loader";

export const API_URL = `${process.env.REACT_APP_QUESTIONS_URL}/v1`;

export const questionsLoader = new Loader(API_URL);
